import React, {useState} from "react";
import PropTypes from "prop-types";
import Modal from "../../shared/modal";
import styles from "./styles.css";
import CloseButton from "../../shared/icon-cross";
// import RepairIcon from "./images/repair-icon.svg";
import ImageSliderModal from "../image-slider-modal/component";
import { NUMBER } from "../../../constants/app-constants";

const ServiceHistoryRevampModal = ({config, content = {}, onClose}) => {
    const {serviceHistory = [], serviceHistoryImages = []} = content;
    const [showImageModal, setShowImageModal] = useState(false);
    const [currentImageSlide, setCurrentImageSlide] = useState(0);
    const showImageModalHandler = () => {
        setShowImageModal(!showImageModal);
    };
    return (
        <React.Fragment>
            <Modal isOpen={true}>
                <div styleName={"styles.outer"}>
                    <div styleName={"styles.headerWrap"}>
                        <p>Service History Logs</p>
                        <span styleName={"styles.close"}>
                            <CloseButton type={"modalClose"} onClickHandler={onClose}/></span>
                    </div>
                    <div styleName={"styles.contentWrap"}>
                        <div styleName={"styles.contentContainer"}>

                            <div styleName="styles.serviceHistoryTimelineWrapper">
                                {serviceHistory.map(({serviceDate, postService = {}, serviceCenterAddress}, index) =>
                                    (
                                        <div key={index} styleName={"styles.recentServiceSectionWrap"}>
                                            <div styleName={"styles.dateWrapper"}>
                                                <p styleName={"styles.serviceDate"}>{serviceDate}</p>
                                                {postService.odo && <p styleName={"styles.kmWrapper"}>{postService.odo} Km</p>}
                                            </div>
                                            <p styleName={"styles.serviceCenterAddress"}>{serviceCenterAddress}</p>
                                        </div>
                                    )
                                )}
                            </div>
                            <div styleName={serviceHistoryImages?.length === NUMBER.ONE ? "styles.serviceHistoryOneImageSection" : "styles.serviceHistoryImageSection"} onClick={showImageModalHandler}>
                                {
                                    Array.isArray(serviceHistoryImages) && serviceHistoryImages.map((img, index) => <img key={index} src={img} onClick={() => setCurrentImageSlide(index)}/>)
                                }
                            </div>
                        </div>
                    </div>
                </div>
                {showImageModal && serviceHistoryImages.length > 0 && <ImageSliderModal images={[{image: serviceHistoryImages[currentImageSlide]}]} isAbsoluteImageUrls config={config} onClose={showImageModalHandler} selectedSlide={currentImageSlide}/>}
            </Modal>
        </React.Fragment>
    );
};

ServiceHistoryRevampModal.propTypes = {
    onClose: PropTypes.func,
    config: PropTypes.object,
    content: PropTypes.func
};

export default ServiceHistoryRevampModal;
